import { Drawer } from "@design-system/Drawer";
import { useOverlays } from "contexts/OverlayContext";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { DownloadIcon } from "@icons";
import { FinancialDocumentFromSchema } from "@common/types/financialDocument";
import { HStack } from "@design-system/HStack/HStack";
import { FinancialDocumentPreview } from "./FinancialDocumentDetails/FinancialDocumentPreview";
import { useDownloadFinancialDocumentFile } from "./FinancialDocumentDetails/useDownloadFinancialDocumentFile";
import previewStyles from "./FinancialDocumentDetails/FinancialDocumentPreview.module.scss";

interface Props {
    financialDocument: FinancialDocumentFromSchema;
    open: boolean;
}

export const FinancialDocumentDrawerContent: React.FC<Props> = ({
    financialDocument,
    open,
}) => {
    const { closeOverlay } = useOverlays();

    const { download, isDownloading } =
        useDownloadFinancialDocumentFile(financialDocument);

    return (
        <Drawer
            open={open}
            onClose={closeOverlay}
            size="half"
            direction="right"
            headerAddonLeft={
                <HStack justify="between" align="center" className="w-100">
                    {financialDocument.fileName}
                    <ButtonWithLoader
                        variant="secondary"
                        size="md"
                        iconOnly
                        aria-label="Download document"
                        onClick={() => {
                            void download();
                        }}
                        loading={isDownloading}
                        tooltip="Download"
                        data-testid="download-financial-document-file"
                    >
                        <DownloadIcon />
                    </ButtonWithLoader>
                </HStack>
            }
        >
            <FinancialDocumentPreview
                financialDocument={financialDocument}
                className={previewStyles.drawerView}
            />
        </Drawer>
    );
};
